<template>
  <div class="m-filters-and-actions m-feed-section-search">
    <form
      autocomplete="off"
      class=""
      name="simple-filters-form"
      @submit.prevent="searchFilter"
    >
      <div class="align-items-baseline display-flex-row-center search-input-holder">
        <i class="far fa-search"></i>
        <AtomInputPrimary
          v-model="filter.name"
          class="project-name"
          name="item"
          placeholder="¿Qué formación buscas?"
          type="text"
          wrapperClass="a-input-wrapper-row"
          @input="searchName"
        />
      </div>

      <div class="display-flex-row space-between width-100-pr">
        <div>
          <div class="m-dropdown-primary">
            <AtomButtonSecondary
              :button-secondary="buttonSecondary.filter"
              @switchDropDown="$dropDown.switchDropDown"
            />
            <MoleculeFeedProjectsSearchDropDownFilters
              :filter-seted="filter"
              @reload="reload"
              @searchFilter="searchFilter"
            />

          <AtomButtonSecondary
            :button-secondary="buttonSecondary.reload"
            @reload="reload"
          />

          <span class="proyects-amount-desktop margin-left-small text-color-black-35">
            {{ `Mostrando ${showedCards} de ${totalCards} resultados` }}
          </span>
          </div>
        </div>

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.create"
          @showModal="$modal.showModal"
        />
      </div>
    </form>

    <span class="proyects-amount-mobile margin-left-small margin-top-xlarge text-align-center text-color-black-35 width-100-pr">
      {{ `Mostrando ${showedCards} de ${totalCards} resultados` }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedProjectsSearch',

  components: {
    MoleculeFeedProjectsSearchDropDownFilters: () => import('@/components/molecules/MoleculeFeedProjectsSearchDropDownFilters')
  },

  props: {
    filterSeted: Object,
    showedCards: Number,
    totalCards: Number
  },

  data () {
    return {
      buttonSecondary: {
        create: {
          class: 'a-button-feed-projects-secondary',
          component: 'MoleculeFeedProjectsContentModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: 'Crear Formación',
          type: 'button'
        },

        filter: {
          class: 'a-button-assets-secondary a-button-side',
          component: 'MoleculeFeedProjectsSearchDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: 'Filtros',
          type: 'button'
        },

        reload: {
          class: 'a-button-assets-secondary a-button-side',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reload',
          text: 'Actualizar',
          type: 'button'
        }
      },

      filter: {
        name: '',
        project_type: 11,
        sort_type: 0,
        state: [0, 1]
      }
    }
  },

  methods: {
    reload () {
      this.filter = {
        name: '',
        project_type: 11,
        sort_type: 0,
        state: [0, 1]
      }

      this.$emit('reload')
    },

    searchFilter (filtros) {
      this.filter = {
        ...this.filter,
        project_type: filtros.project_type,
        sort_type: filtros.sort_type,
        state: [...filtros.state]
      }
      this.$emit('searchFilter', this.filter)
    },

    searchName () {
      this.$emit('searchFilter', this.filter)
    }
  }
}
</script>
